import React from "react";

import RegisterLayout from "@/features/auth/components/registerLayout/RegisterLayout";

function PaymentPlans() {
	return <RegisterLayout isPlansPage={true} />;
}

export default PaymentPlans;
